import { createAction } from 'redux-api-middleware'

import { HUBBLE_API_TOKEN } from '../store/middleware/APIUrl'
import { Chain } from '../types';
import { RootState } from '../reducers';

const ChainsActions = {
    CHAINS_FETCH_REQUEST: 'CHAINS_FETCH##REQUEST',
    CHAINS_FETCH_SUCCESS: 'CHAINS_FETCH##SUCCESS',
    CHAINS_FETCH_FAILURE: 'CHAINS_FETCH##FAILURE',
} as const

type FetchChainsRequest = {
    type: typeof ChainsActions.CHAINS_FETCH_REQUEST;
    payload: never;
}

type FetchChainsFailure = {
    type: typeof ChainsActions.CHAINS_FETCH_FAILURE;
    payload: Error;
}

type FetchChainsSuccess = {
    type: typeof ChainsActions.CHAINS_FETCH_SUCCESS;
    payload: Chain[];
}

/**
 * Fetch chains information
 */
function fetchChains() {
    return createAction<RootState, Chain[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/chains`,
        method: 'GET',
        types: [
            ChainsActions.CHAINS_FETCH_REQUEST,
            ChainsActions.CHAINS_FETCH_SUCCESS,
            ChainsActions.CHAINS_FETCH_FAILURE,
        ],
    })
}

export type AnyChainsAction = FetchChainsRequest
    | FetchChainsFailure
    | FetchChainsSuccess

export { ChainsActions, fetchChains }
